/* eslint-disable */
export const formatNumber = (number) => {
  let numberFormat = Number(number).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return numberFormat;
};

export const formatNumberVolume = (number) => {
  let numberFormat = Number(number).toLocaleString("th-TH", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
  return numberFormat;
};

export const formatNumberDensity = (number) => {
  let numberFormat = Number(number).toLocaleString("th-TH", { minimumFractionDigits: 6, maximumFractionDigits: 6 });
  return numberFormat;
};
